// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"703":"8b6c9220","753":"64d808bb"}[chunkId] + ".chunk.css";
};